module.exports = __webpack_public_path__ + "static/media/Quagsire_gaussian2.49221966.png";